import type { WmtsLayerRaw } from '@tsyl/karonte/lib/types/layers'

const vegetationSouthAmerica: WmtsLayerRaw = {
  type: 'WMTS',
  id: 'VegetationWorldCover',
  title: {
    'en-US': 'Vegetation World Cover',
    'pt-BR': 'Vegetacion Mundial',
    'es-ES': 'Vegetacion Mundial',
    'fr-FR': 'Couverture mondiale de la végétation'
  },
  icon: 'mdi-leaf',
  active: true,
  enabled: false,
  zindex: 1,
  legend: {
    title: {
      'en-US': 'Vegetation World Cover',
      'pt-BR': 'Vegetacion Mundial',
      'es-ES': 'Vegetacion Mundial',
      'fr-FR': 'Couverture mondiale de la végétation'
    },
    items: [
      {
        text: {
          'en-US': 'Tree cover',
          'pt-BR': 'Cobertura de árvore',
          'es-ES': 'Cobertura arbórea',
          'fr-FR': 'Couverture arborée'
        },
        color: '#006400',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Shrubland',
          'pt-BR': 'Arbustos',
          'es-ES': 'Matorral',
          'fr-FR': 'Arbustes'
        },
        color: '#ffbb22',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Grassland',
          'pt-BR': 'Pastagem',
          'es-ES': 'Pradera',
          'fr-FR': 'Prairie'
        },
        color: '#ffff4c',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Cropland',
          'pt-BR': 'Terras agrícolas',
          'es-ES': 'Tierras de cultivo',
          'fr-FR': 'Terres cultivées'
        },
        color: '#f096ff',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Built-up',
          'pt-BR': 'Construído',
          'es-ES': 'Construido',
          'fr-FR': 'Construit'
        },
        color: '#fa0000',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Sparse vegetation / Bare',
          'pt-BR': 'Vegetação nua / esparsa',
          'es-ES': 'Vegetación desnuda / rala',
          'fr-FR': 'Végétation nue / éparse'
        },
        color: '#b4b4b4',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Snow and ice',
          'pt-BR': 'Neve e gelo',
          'es-ES': 'Nieve y hielo',
          'fr-FR': 'Neige et glace'
        },
        color: '#f0f0f0',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Permanent water bodies',
          'pt-BR': 'Corpos de água permanentes',
          'es-ES': 'Masas de agua permanentes',
          'fr-FR': "Plans d'eau permanents"
        },
        color: '#0064c8',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Herbaceous wetland',
          'pt-BR': 'Pantanal Herbáceo',
          'es-ES': 'Humedal herbáceo',
          'fr-FR': 'Zone humide herbacée'
        },
        color: '#0096a0',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Mangroves',
          'pt-BR': 'Manguezais',
          'es-ES': 'Manglares',
          'fr-FR': 'Les mangroves'
        },
        color: '#00cf75',
        icon: 'mdi-square'
      },
      {
        text: {
          'en-US': 'Moss and lichen',
          'pt-BR': 'Musgo e líquen',
          'es-ES': 'Musgo y liquen',
          'fr-FR': 'Mousse et lichen'
        },
        color: '#fae6a0',
        icon: 'mdi-square'
      }
    ]
  },
  opacity: 0.5,
  customProperties: { group: 'reference' },
  url: 'https://services.terrascope.be/wmts/v2',
  name: 'WORLDCOVER_2021_MAP'
}

export default vegetationSouthAmerica
